module.exports = __webpack_public_path__ + "static/media/bannerimg06.6f8fe282.jpg";